<template>
  <management-page :pageName="pageName" :menu="menu" class="management" />
</template>

<script>
import ManagementPage from "@/components/Management/Management";
import { managementViewMixin } from "@/mixins/management/managementViewMixin";
import AccountsSVG from "@/assets/management/accounts.svg";

export default {
  name: "SoftwareLicenses",

  components: { ManagementPage },

  mixins: [managementViewMixin],

  computed: {
    /**
     * Determine the page title
     * @returns {VueI18n.TranslateResult}
     */
    pageName() {
      return this.$i18n.t("SoftwareLicenses");
    },
    /**
     * Determines the menu available in the sidebar on the page
     * @returns {[{submenu: [{route: string, dev: boolean, name: VueI18n.TranslateResult, disabled: boolean}], name: VueI18n.TranslateResult, icon, disabled: boolean}]}
     */
    menu() {
      return [
        {
          name: this.$i18n.t("About"),
          icon: AccountsSVG,
          disabled: false,
          submenu: [
            {
              name: this.$i18n.t("License"),
              route: "about-licenses",
              disabled: false,
              dev: false
            }
          ]
        }
      ];
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/SoftwareLicenses.vue